import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    Home, Type, PanelBottom, Mail, HardHat, DollarSign, Zap, Mountain, Building2,
    LogOut, Image as ImageIcon, Briefcase, MapPin, Target, Plane, Truck, Info, KeyRound
} from 'lucide-react';

const AdminSidebar: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const navItems = [
        { id: 'dashboard', label: 'Homepage Editor', icon: Home, path: '/admin/dashboard' },
        { id: 'profile', label: 'Reset Password', icon: KeyRound, path: '/admin/profile' },
        { id: 'header', label: 'Header Editor', icon: Type, path: '/admin/header' },
        { id: 'footer', label: 'Footer Editor', icon: PanelBottom, path: '/admin/footer' },
        { id: 'about', label: 'About Group Editor', icon: Info, path: '/admin/about' },
        { id: 'careers', label: 'Careers Editor', icon: Briefcase, path: '/admin/careers' },
        { id: 'contact', label: 'Contact Editor', icon: Mail, path: '/admin/contact' },
        { id: 'mining', label: 'Mining Editor', icon: Mountain, path: '/admin/mining' },
        { id: 'gabbro', label: 'Gabbro Editor', icon: Zap, path: '/admin/gabbro' },
        { id: 'construction', label: 'Construction Editor', icon: HardHat, path: '/admin/construction' },
        { id: 'transport', label: 'Transport Editor', icon: Truck, path: '/admin/transport' },
        { id: 'realestate', label: 'Al Baz Real Estate Editor', icon: MapPin, path: '/admin/realestate' },
        { id: 'alyasminah', label: 'Al Yasminah Editor', icon: Building2, path: '/admin/alyasminah' },
        { id: 'plaza', label: 'Plaza Hotel Editor', icon: Building2, path: '/admin/plaza' },
        { id: 'exchange', label: 'Exchange Editor', icon: DollarSign, path: '/admin/exchange' },
        { id: 'travel', label: 'Travel Editor', icon: Plane, path: '/admin/travel' },
        { id: 'tyres', label: 'Tyres Editor', icon: Target, path: '/admin/tyres' },
    ];

    const handleLogout = () => {
        localStorage.removeItem('adminToken');
        localStorage.removeItem('adminUser');
        navigate('/admin/login');
    };

    return (
        <aside className="w-20 lg:w-72 bg-slate-900 flex flex-col shrink-0 transition-all duration-300">
            <div className="p-6 border-b border-slate-800 flex items-center lg:space-x-4">
                <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center shrink-0">
                    <Building2 className="w-6 h-6 text-white" />
                </div>
                <span className="hidden lg:block text-xl font-bold text-white tracking-tight">Hamdan CMS</span>
            </div>

            <nav className="flex-1 p-4 space-y-2 flex flex-col items-center lg:items-stretch overflow-y-auto no-scrollbar">
                {navItems.map(item => (
                    <button
                        key={item.id}
                        onClick={() => navigate(item.path)}
                        className={`flex items-center space-x-4 px-4 py-3 rounded-xl transition-all group ${location.pathname === item.path ? 'bg-blue-600/10 text-blue-400' : 'text-slate-500 hover:text-blue-400 hover:bg-blue-600/5'}`}
                    >
                        <item.icon className="w-5 h-5 shrink-0" />
                        <span className="hidden lg:block font-bold">{item.label}</span>
                    </button>
                ))}
            </nav>

            <div className="p-4 border-t border-slate-800">
                <button
                    onClick={handleLogout}
                    className="flex items-center space-x-4 px-4 py-3 rounded-xl text-slate-500 hover:text-red-400 hover:bg-red-400/5 w-full transition-all group"
                >
                    <LogOut className="w-5 h-5 shrink-0" />
                    <span className="hidden lg:block font-bold">Log out</span>
                </button>
            </div>
        </aside>
    );
};

export default AdminSidebar;
